import React from "react";
import Tooltip from "rc-tooltip";

export default function Info(props) {
    return <Tooltip placement="left" overlay={ props.help }><span className="oi oi-info clickable text-primary"></span></Tooltip>
}

